// import hooks
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'hooks';

// import types
import { TabType } from './CLASettings.types';

// import components
import { Tab } from '@mui/material';
import UnsavedDataAlert from 'components/shared/CRUD/components/InnerPage/components/UnsavedDataAlert';
import { useEditPageContext } from '../../../shared/CRUD/components/InnerPage/EditPageContext';
import TabSwitcher from './TabSwitcher';
import { StyledDetailViewTabs } from './DetailView.styles';
import { StyledUnsavedDataAlertBox } from 'components/shared/CRUD/components/InnerPage/EditPage.styles';

// imports external libraries
import { AnimatePresence } from 'motion/react';

// import types
import { TabsAtClaSettingsProps } from './DetailView.types';

const TabsAtClaSettings = ({ setCurrentSchema }: TabsAtClaSettingsProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla.sectionTitles'
  });
  const {
    hasProcessEndOfEmploymentSettlementAccess,
    hasSpecialLeaveImportModule
  } = useSelector((state) => state.grants);
  const { isEditable } = useEditPageContext();
  const [value, setValue] = useState<TabType>(TabType.GENERAL);
  const { formState } = useFormContext();
  const handleChange = (event: React.SyntheticEvent, newValue: TabType) => {
    setValue(newValue);
  };

  return (
    <>
      <StyledDetailViewTabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        {Object.values(TabType).map((tabItem, index) => {
          if (
            (tabItem === TabType.END_OF_EMPLOYMENT_SETTLEMENT &&
              !hasProcessEndOfEmploymentSettlementAccess) ||
            (tabItem === TabType.SPECIAL_LEAVE && !hasSpecialLeaveImportModule)
          )
            return null;

          return (
            <Tab
              key={index}
              value={tabItem}
              label={t(tabItem)}
              disabled={isEditable}
              component="a"
            />
          );
        })}
      </StyledDetailViewTabs>
      <AnimatePresence mode="wait">
        {formState.isDirty ? (
          <StyledUnsavedDataAlertBox
            key="motion-unsaved-detail-view"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
          >
            <UnsavedDataAlert />
          </StyledUnsavedDataAlertBox>
        ) : (
          ''
        )}
      </AnimatePresence>

      <TabSwitcher currentTab={value} setCurrentSchema={setCurrentSchema} />
    </>
  );
};

export default TabsAtClaSettings;
